import { Platform, StyleSheet } from 'react-native';

export const oStyles = StyleSheet.create({
    default_container: {
        flex: 1,
        backgroundColor: '#c2ce4e',
        paddingTop: 50
    },
    default_header: {
        backgroundColor: '#3c5f42',
    },
    background: {
        flex: 1
    },
    main_container: {
        flex: 1,
        backgroundColor: '#c2ce4e',
    },
    viewer_container: {
        flex: 1,
    },
    control_panel: {
        width: '100%',
        height: Platform.OS === 'web' ? '80px' : '12%',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#c2ce4e'
    },
    player_container: {
        height: Platform.OS === 'web' ? '80px' : '12%',
        flexDirection: 'row',
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        backgroundColor: '#c2ce4e',
        borderWidth: 2,
        borderColor: '#3c5f42',
        paddingLeft: 10,
        alignItems: 'center'
    },
    player_title: {
        flex: 1,
        fontSize: 18,
        color: 'white'
    },
    button_default: {
        backgroundColor: '#3c5f42',
        height: 50,
        borderRadius: 7,
        justifyContent: 'center',
        shadowColor: '#000000',
        shadowOffset: {
            width: 3,
            height: 3
        },
        shadowRadius: 5,
        shadowOpacity: 0.6,
        elevation: 4,
    },
    button_default_text: {
        color: 'white',
        fontFamily: 'futuris'
    },
    button: {
        marginLeft: '10%',
        marginRight: '10%',
        marginTop: 10,
        marginBottom: 10,
    },
    button_text: {
        paddingLeft: 40,
        fontSize: 18,
    },
    about_container: {
        backgroundColor: 'white'
    },
    about_image: {
        width: Platform.OS === 'web' ? 300 : '90%',
        height: 130,
        resizeMode: 'contain',
        alignSelf: 'center'
    },
    about_title: {
        marginTop: 10,
        marginLeft: 10,
        marginRight: 10,
        textAlign: 'center',
        fontSize: 18,
        fontFamily: 'times-bold'
    },
    about_content: {
        marginLeft: 10,
        marginRight: 10,
        marginBottom: 10,
    },
    about_button: {
        marginLeft: '10%',
        marginRight: '10%',
        marginTop: 10,
        justifyContent: 'center'
    },
    about_button_text: {
        paddingLeft: 5,
        paddingRight: 5,
        color: '#3c5f42',
        textAlign: 'center',
        fontSize: 12,
    },
    answer_button: {
        height: 40,
        backgroundColor: '#3c5f42',
        justifyContent: 'center'
    },
    answer_button_text: {
        color: 'white',
        textAlign: 'center',
        fontFamily: 'futuris'
    },
    test_title: {
        textAlign: 'center',
        fontSize: 18,
        fontFamily: 'times-bold',
        marginTop: 10
    },
    test_text: {
        textAlign: 'center',
        fontSize: 12,
        fontFamily: 'times',
        marginLeft: 2,
        marginRight: 2,
        marginTop: 10,
        marginBottom: 20
    },
    test_question: {
        fontSize: 12,
        fontFamily: 'times',
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 3
    },
    test_input: {
        color: 'black',
        height: 40,
        fontSize: 12,
        borderWidth: 2,
        borderColor: 'gray',
        borderRadius: 3,
        marginBottom: 10,
        marginLeft: 5,
        marginRight: 5,
        paddingLeft: 10,
        paddingRight: 10
    },
    test_button: {
        borderWidth: 2,
        borderRadius: 3,
        marginLeft: 5,
        marginRight: 5,
        marginTop: 8,
        paddingLeft: 2,
        paddingRight: 2,
        paddingTop: 8,
        paddingBottom: 8,
        borderColor: 'gray'
    },
    test_button_text: {
        textAlign: 'center',
        fontSize: 12,
        fontFamily: 'times'
    },
    exercises_title: {
        textAlign: 'center',
        fontFamily: 'times-bold',
        marginTop: 5,
        marginLeft: 3,
        marginRight: 3
    },
    exercises_title_translate: {
        textAlign: 'center',
        fontFamily: 'times',
        marginTop: 5,
        marginLeft: 3,
        marginRight: 3
    },
    exercises_question: {
        fontFamily: 'times',
        marginTop: 10,
        marginLeft: '10%',
        marginBottom: 30
    },
    exercises_answer: {
        fontFamily: 'times',
        marginLeft: 10,
        marginRight: 10
    },
    panel_button: {
        width: '45%',
        marginLeft: '2%',
        marginRight: '2%'
    },
    panel_button_text: {
        color: 'white',
        textAlign: 'center',
    },
    control_button: {
        width: 50,
        height: 40,
        marginLeft: '2%',
        marginRight: '2%'
    },
    control_button_text: {
        textAlign: 'center',
        fontWeight: 'bold'
    },
    control_input: {
        height: 40,
        width: 80,
        marginLeft: '2%',
        marginRight: '2%',
        borderColor: 'silver',
        borderWidth: 1,
        borderRadius: 4,
        alignItems: 'center',
        backgroundColor: 'white'
    },
    control_input_text: {
        marginTop: 5,
        fontSize: 18,
    },
    list_item: {
        height: 50,
        backgroundColor: 'silver',
        borderWidth: 1,
        borderColor: 'gray',
        borderRadius: 5
    },
    list_item_text: {
        marginLeft: 10,
        marginTop: 10,
        fontSize: 18,
        fontWeight: 'bold',
        color: 'white'
    },
    dictionary_page_container: {
        flex: 1, 
        backgroundColor: '#c2ce4e'
    },
    dictionary_item: {
        paddingLeft: 5,
        paddingTop: 2,
        paddingRight: 5,
        fontSize: 12
    },
    dictionary_link: {
        fontSize: 10,
        color: 'blue',
        textAlignVertical: 'bottom'
    },
    advanced_search_button: {
        justifyContent: 'center',
        paddingTop: 10,
        paddingBottom: 10,
    },
    advanced_search_button_text: {
        color: '#3c5f42',
        textAlign: 'center',
    }
});